import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import { Shipment } from '../types';
import Step1ChooseCarrier from './Step1ChooseCarrier';
import Step2UnbilledShipments from './Step2UnbilledShipments';
import Step3FinalSubmit from './Step3FinalSubmit';
import SbButton from '@Components/Button';
import Image from '@Components/Image';
import Title from '@Components/Title';
import { useLocation, useNavigate } from 'react-router-dom';

const DebitNotePurchaseInvoice: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [activeStep, setActiveStep] = useState(0);
  const [carrierId, setCarrierId] = useState<string>('');
  const [shipments, setShipments] = useState<Shipment[]>([]);
  const [selectedShipments, setSelectedShipments] = useState<Shipment[]>([]);
  const steps = ['Choose Carrier', 'Unbilled Shipments', 'Final Submission'];

  const handleNext = () => setActiveStep(prev => prev + 1);
  const handleBack = () => setActiveStep(prev => prev - 1);

  const handleCarrierSelect = (carrierId: string) => {
    setCarrierId(carrierId);
  };

  useEffect(() => {
    if (location?.state?.carrierId && location?.state?.shipments) {
      setCarrierId(location?.state?.carrierId);
      setShipments(location?.state?.shipments);
      setActiveStep(1);
    }
  }, [location]);

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
        <Box
          onClick={() => {
            if (activeStep === 0) {
              navigate('/purchase-invoices');
            } else if (activeStep === 1) {
              setActiveStep(0);
            } else {
              setActiveStep(1);
            }
          }}
          sx={{ zIndex: '1', cursor: 'pointer' }}
        >
          <Image src="/images/backbutton.svg" alt="Back Button" style={{ width: '1.5rem', marginTop: '0.2rem' }} />
        </Box>
        <Title title="Purchase Invoices" subTitle="View and create purchase invoices" />
      </Box>
      <Box sx={{ mt: 4 }}>
        <Title removeBorder title="Create Debit Note" titleClass="underline px_20-text" />

        {activeStep === 0 && (
          <Step1ChooseCarrier selectedCarrier={carrierId} onChange={handleCarrierSelect} onNext={handleNext} />
        )}
        {activeStep === 1 && (
          <Step2UnbilledShipments
            carrierId={carrierId}
            shipments={shipments}
            setShipments={setShipments}
            selectedShipments={selectedShipments}
            setSelectedShipments={setSelectedShipments}
          />
        )}

        {activeStep === 2 && <Step3FinalSubmit carrierId={carrierId} selectedShipments={selectedShipments} />}
      </Box>

      {/* Global Navigation */}

      <Box
        sx={{
          mt: 3,
          display: 'flex',
          justifyContent: 'flex-end',
          width: '100%',
        }}
      >
        <Box sx={{ display: 'flex', gap: 5, width: '30%', maxWidth: 400 }}>
          {activeStep !== 2 && (
            <SbButton
              variant="outlined"
              fullWidth
              className="rounded-full"
              disabled={activeStep === 0}
              onClick={handleBack}
            >
              Back
            </SbButton>
          )}

          {activeStep < steps.length - 1 && (
            <SbButton
              variant="contained"
              fullWidth
              className="rounded-full"
              onClick={handleNext}
              disabled={(activeStep === 0 && !carrierId) || (activeStep === 1 && selectedShipments.length === 0)}
            >
              Next
            </SbButton>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default DebitNotePurchaseInvoice;
